export default __webpack_public_path__ + "static/media/Orange.19c24a28.svg";